<div class="d-flex align-items-center mb-4">
  <div class="fw-bold text-primary font-weight-medium m-0">Template</div>
  <div *ngIf="loading" class="spinner-grow spinner-grow-sm ms-3" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <select class="form-select m-0 ms-auto" [(ngModel)]="details_template" (ngModelChange)="saveTemplate()" style="width: 180px">
    <option [value]="template.id" *ngFor="let template of templates">{{ template.name }}</option>
  </select>
</div>
